export const VACATION_LEAVES_TYPES = {
  'Annual Leave': 'Annual Leave',
  'Birthday Leave': 'Birthday Leave',
  'Casual Leave': 'Casual Leave',
  'Hajj Leave': 'Hajj Leave',
  'Maternity/Paternity Leave': 'Maternity/Paternity Leave',
  'Sick Leave': 'Sick Leave',
  'Study Leave': 'Study Leave',
  'Unpaid Leave': 'Unpaid Leave',
  'Other Time off': 'Other Time off',
};
